import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import TimesheetSystemReport from '../../components/Ticket/TimesheetSystem/TimesheetSystemReport/TimesheetSystemReport';
export default class TimesheetSystemReportPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <TimesheetSystemReport/>
            </div>
        )
    }
}